var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"label px-2",style:(_vm.labelStyle)},[_vm._t("default",[_vm._v("まとめて割引")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }